import { useEffect } from "react";
import { applySeo } from "../utils/seo";

function useSeo(seo) {
    useEffect(() => {
        applySeo(seo);
    }, [seo]);
}

export default useSeo;
